module.exports = __webpack_public_path__ + "static/media/skill-icons--gcp-dark.3bf5c97c.png";